import React from 'react';
import store from '../store/Store';

import Contribution from '../components/contribution/Contribution'

import './mainView.scss';

type mainViewState = {
	
}

type mainViewProps = {
	
}

class MainView extends React.Component<mainViewState, mainViewProps> {

	constructor(props) {
		super(props)

		this.state = {
			
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				
			})
		})
	}

	render() {
	  return (
	    <div className="MainView">
	    	<Contribution
	    		article={ store.getState().article }
	    		navigation={ store.getState().navigation }
	    	/>
	    </div>
	  )
	}
}

export default MainView;